
import { BillingPage } from '@/features/billing';

export default function Billing() {
  return <BillingPage />;
}
